import { Context, useCallback, useContext } from "react";
import { LocalizationContext } from "../../localization-context";
import {
  LocalizationContext as LocalizationContextType,
  TranslateFunction,
} from "../../types";

export const useTranslation = <
  Locale extends string,
  NS extends string = string
>(
  namespace?: NS
) => {
  /**
   * Some hack here for correct generic types, also language always persists
   */
  const translationContext = useContext<
    Omit<LocalizationContextType<Locale>, "language"> & { language: Locale }
  >(
    LocalizationContext as unknown as Context<
      Omit<LocalizationContextType<Locale>, "language"> & { language: Locale }
    >
  );

  if (!translationContext) {
    throw new Error(
      "Localization provider not found. Please wrap you app into LocalizationProvider"
    );
  }

  const { language, translate, changeLanguage } = translationContext;

  /**
   * TODO possibly remove after v.23 upgrade
   */
  const translateWithNameSpace = useCallback(
    (...args: Parameters<TranslateFunction>) => {
      if (!translate) {
        return;
      }

      const [key, options] = args;

      return translate(key, {
        ...options,
        ...(!options?.ns && { ns: namespace }),
      });
    },
    [translate, namespace]
  ) as TranslateFunction;

  return {
    language,
    translate: translateWithNameSpace,
    changeLanguage,
  };
};
